import React, { useEffect, useState } from "react";
import "../styles/AchievementPopup.css";

export default function AchievementPopup({ achievement, onClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, [achievement]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  if (!achievement) return null;

  return (
    <div className="ach-overlay" onClick={handleClose}>
      <div
        className={`ach-popup ${visible ? "ach-popup--visible" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ach-glow" />
        <div className="ach-icon-wrap">
          {achievement.icon_url ? (
            <img src={achievement.icon_url} alt="" className="ach-icon" />
          ) : (
            <span className="ach-icon-fallback">🏅</span>
          )}
        </div>
        <span className="ach-label">Achievement Unlocked!</span>
        <h2 className="ach-name">{achievement.name}</h2>
        <p className="ach-desc">{achievement.description}</p>
        {achievement.xp_reward > 0 && (
          <span className="ach-xp">+{achievement.xp_reward} XP</span>
        )}
        {achievement.cosmetic && (
          <div className="ach-reward">
            <span className="ach-reward-label">
              Reward:{" "}
              {achievement.cosmetic.type === "avatar"
                ? "Avatar"
                : achievement.cosmetic.type === "border"
                ? "Border"
                : achievement.cosmetic.type}
            </span>
          </div>
        )}
        <button className="ach-btn" onClick={handleClose}>Continue</button>
      </div>
    </div>
  );
}